import { useSelector } from 'app-redux'
import { RootState } from 'common/redux'
import KnowledgeCheckThreeColumnsVideoGrid from 'features/knowledge-checks/presentation/knowledge-check-three-columns-video-grid'
import ThreeColumnsVideoGrid from 'room/training-room/ice-breaker/presentation/three-columns-video-grid'
import { SceneVideoUser } from 'video-conference-media'

type Props = {
	streams: Array<SceneVideoUser>
	children: React.ReactNode
}
export const VideoLayoutKnowledgeCheckResolver: React.FC<Props> = ({
	streams,
	children,
}) => {
	const isReview = useSelector(
		(state: RootState) => state.knowledgeChecks.isReview
	)

	return isReview ? (
		<ThreeColumnsVideoGrid sceneVideoUsers={streams}>
			{children}
		</ThreeColumnsVideoGrid>
	) : (
		<KnowledgeCheckThreeColumnsVideoGrid sceneVideoUsers={streams}>
			{children}
		</KnowledgeCheckThreeColumnsVideoGrid>
	)
}
